module.exports = __webpack_public_path__ + "media/images/meta/yogasix/apple-touch-icon-872babbc9cdf579bc293bb066c023db9.png";